const fileExtensions = [
  '.ogg',
  '.oga',
  '.mogg',
  '.3gp',
  '.aa',
  '.aac',
  '.aax',
  '.act',
  '.aiff',
  '.amr',
  '.ape',
  '.au',
  '.awb',
  '.dct',
  '.dss',
  '.dvf',
  '.flac',
  '.gsm',
  '.iklax',
  '.ivs',
  '.m4a',
  '.m4b',
  '.m4p',
  '.mmf',
  '.mp3',
  '.mpc',
  '.msv',
  '.nmf',
  '.nsf',
  '.opus',
  '.ra',
  '.rm',
  '.raw',
  '.sln',
  '.tta',
  '.voc',
  '.vox',
  '.wav',
  '.wma',
  '.wv',
  '.webm',
  '.8svx',
];
export default fileExtensions;

export function isAudioFile(fileName: string) {
  return fileExtensions.some((x) => fileName.toLowerCase().endsWith(x));
}

/**
 * The extension a file name carries, lower case and without the dot -
 * "mp3", "m4a", "aiff" - which is what the Format column shows. Nothing for
 * a name without one, or a dotfile.
 *
 * Not validated against the list above: a file reached the library through
 * the audio filters, and its extension is whatever it is.
 */
export function fileFormat(fileName: string | null | undefined) {
  const match = fileName?.match(/[^.]\.([^./\\]+)$/);

  return match ? match[1].toLowerCase() : undefined;
}
